module.exports = __webpack_public_path__ + "img/off_paletizadora.84fbd4fc.png";